import React, {useContext, useEffect} from 'react';
import {observer} from 'mobx-react-lite';
import {Context} from '..';
import {AuthenticatedWebSocket} from './authenticatedWebSocket';
import {WS_CHAT_URL} from './config';

let socketInstance = null;

class ChatWebSocketService {
    constructor() {
        this.socketClient = null;
    }

    setupWebSocket(user) {
        this.close();

        this.socketClient = new AuthenticatedWebSocket({
            url: WS_CHAT_URL,
            name: 'Chat WebSocket',
            onMessage: (event, socket) => {
                let data;

                try {
                    data = JSON.parse(event.data);
                } catch (error) {
                    console.error('Chat WebSocket: ошибка парсинга JSON', event.data);
                    return;
                }

                if (data.type === 'ping') {
                    socket.send({type: 'pong'});
                    return;
                }

                if (data?.chat !== undefined) {
                    const messagesToAdd = Array.isArray(data.data)
                        ? data.data
                        : data.data && typeof data.data === 'object'
                            ? [data.data]
                            : [];

                    if (messagesToAdd.length === 0) {
                        console.warn('Chat WebSocket: неожиданный формат сообщения', data.data);
                        return;
                    }

                    user.setChat({
                        chat: data.chat,
                        data: messagesToAdd,
                    });
                    return;
                }

                console.log('Chat WebSocket: получено другое сообщение', data);
            },
        });

        this.socketClient.connect();
    }

    close() {
        if (this.socketClient) {
            this.socketClient.stop();
            this.socketClient = null;
        }
    }
}

export const getWebSocketInstance = () => {
    if (!socketInstance) {
        socketInstance = new ChatWebSocketService();
    }

    return socketInstance;
};

const WsUserAPI = observer(() => {
    const {user} = useContext(Context);

    useEffect(() => {
        const webSocket = getWebSocketInstance();
        webSocket.setupWebSocket(user);

        return () => {
            webSocket.close();
        };
    }, [user]);

    return null;
});

export default WsUserAPI;
